import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

/**
 * Prevents organization-fetch failures from being mistaken for a new account.
 * It renders a destructive refresh-to-retry message and performs no retry itself.
 *
 * @returns The organization-loading fallback alert.
 */
export const OrganizationLoadError = () => (
  <div className="mx-auto mt-16 max-w-xl px-6">
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>
        Unable to load your organization. Refresh the page to try again.
      </AlertDescription>
    </Alert>
  </div>
);
